<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-bind="buttonProps"
          :disabled="
            flux.state === 'processing'
            || flux.state === 'pending'
          "
          v-on="on"
          icon
          color="primary"
          @click.stop="openDialog()"
        >
          <v-icon>cached</v-icon>
        </v-btn>
      </template>

      <span>Process {{ flux.name }} feed</span>
    </v-tooltip>

    <v-dialog
      v-model="confirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline"
        >Confirmation</v-card-title>

        <v-card-text>
          <p>You are about to start the processing of the following feed:</p>
          <p class="text-center">
            <strong class="title">{{ flux.name }}</strong>
            <br>
            <small>via {{ $translate.instant(`FLUX_${flux.provider.toUpperCase()}`) }} provider</small>
          </p>
          <p>Are you sure you want to process it?</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            text
            @click="closeDialog()"
          >No, cancel</v-btn>

          <v-btn
            color="primary"
            @click="confirmProcessing()"
            depressed
          >Yes, proceed</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ProcessFluxButton',
  data() {
    return {
      confirmDialog: false
    }
  },
  props: {
    buttonProps: {
      type: Object,
      default() {
        return {
          text: true,
          small: true
        }
      }
    },
    flux: Object
  },
  methods: {
    openDialog() {
      this.confirmDialog = true
    },
    closeDialog() {
      this.confirmDialog = false
    },
    async confirmProcessing() {
      try {
        const { data: { data: flux } } = await this.$axios.put(`/flux/${this.flux.id}/process`, {})
        this.flux.state = flux.state
        this.flux.job_id = flux.job_id
        this.closeDialog()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
